import { toast } from "react-toastify";
import { ToastPromiseParams } from "react-toastify/dist/core/toast";

export const PromiseToaast = (
  promise: Promise<any>,
  message: ToastPromiseParams
) => {
  return toast.promise(promise, message, {
    position: "bottom-left",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    rtl: true,
    theme: "dark",
    style: { fontFamily: "Vazir", fontSize: 14 },
  });
};

export const WarningToaast = (message: string) => {
  return toast.warn(message, {
    position: "bottom-left",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    rtl: true,
    theme: "dark",
    style: { fontFamily: "Vazir", fontSize: 14 },
  });
};

export const ErrorToaast = (message: string) => {
  return toast.error(message, {
    position: "bottom-left",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    rtl: true,
    theme: "dark",
    style: {
      fontFamily: "Vazir",
      fontSize: 14,
    },
  });
};
export const SuccessToaast = (message: string) => {
  return toast.success(message, {
    position: "bottom-left",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    rtl: true,
    theme: "dark",
    style: {
      fontFamily: "Vazir",
      fontSize: 14,
    },
  });
};
export const InfoToaast = (message: string) => {
  return toast.info(message, {
    position: "bottom-left",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    rtl: true,
    theme: "dark",
    style: {
      fontFamily: "Vazir",
      fontSize: 14,
    },
  });
};
